import { authHeader, httpHelper } from '../helpers';
import { post, get } from 'axios';

export const siteService = {
    findSiteList,
    getSiteInfo,
    findSiteListbyUserID,
};

function findSiteList(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/site/list`, formData, headers);
}

function getSiteInfo(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/site/info`, formData, headers);
}

function findSiteListbyUserID(userID){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return get(httpHelper.getApiUrl()+`/site/findSiteListbyUserID/${userID}`, headers);
}